import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagJE = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M44.834 40.222 29.612 25 44.834 9.778a25.265 25.265 0 0 0-4.611-4.612L25 20.388 9.778 5.166a25.237 25.237 0 0 0-4.611 4.612L20.389 25 5.167 40.222a25.252 25.252 0 0 0 4.611 4.612L25 29.61l15.223 15.223a25.262 25.262 0 0 0 4.611-4.612Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M20.652 7.609 25 8.696l4.348-1.087V3.913l-1.74.87L25 2.173l-2.609 2.61-1.739-.87V7.61Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M20.652 7.608v2.718c0 3.328 4.348 4.348 4.348 4.348s4.348-1.02 4.348-4.348V7.608h-8.696Z"
}));
FlagJE.displayName = 'FlagJE';
export default withFlagWrapper(FlagJE);
//# sourceMappingURL=index.js.map